import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';
import Text from '../../elements/Text';
import Button from '../../elements/Button';
import Icon from '../../elements/Icon';
import flavors from './flavors';
import withFlavors from '../../items/_commons/WithFlavors';

const NoResults = (props) => {
  const {
    buttonLabelKey,
    buttonRefreshingLabelKey,
    showButton,
    onClick,
    isRefreshing,
    noResultsHeader,
    noResultsButton,
    showIcon,
    labelKey,
    icon,
    iconProps,
  } = props;
  const { translate, direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });

  return (
    <Box className={`fr-no-result ${className}`} style={style} dataTestId="noResult">
      <Box {...noResultsHeader}>
        <Box>
          <Text>
            {translate(
              labelKey,
              'Unfortunately there are no results available now, come back later.'
            )}
          </Text>
        </Box>
        {showIcon && (
          <Box>
            <Icon {...iconProps} icon={icon} />
          </Box>
        )}
      </Box>
      {showButton && (
        <Button
          {...noResultsButton}
          disabled={isRefreshing}
          onClick={onClick}
          dataTestId="noResultBTN"
        >
          {isRefreshing
            ? translate(buttonRefreshingLabelKey, 'Refreshing...')
            : translate(buttonLabelKey, 'Refresh')}
        </Button>
      )}
    </Box>
  );
};

NoResults.propTypes = {
  /**
   * Translation key
   */
  labelKey: PropTypes.string,
  /**
   * Translation key of the button
   */
  buttonLabelKey: PropTypes.string,
  /**
   * Translation key when the button is loading
   */
  buttonRefreshingLabelKey: PropTypes.string,
  /**
   * Flavor of the fareItem
   */
  flavor: PropTypes.oneOf(['desktop', 'mobile']),
  /**
   * Icon class
   */
  icon: PropTypes.string,
  /**
   * Determine if show the button
   */
  showButton: PropTypes.bool,
  /**
   * Determine if show the icon
   */
  showIcon: PropTypes.bool,
  /**
   * Is Refreshing
   */
  isRefreshing: PropTypes.bool,
  /**
   * Function fired when click the button
   */
  onClick: PropTypes.func,
  /**
   * Settings for noResultsHeader section
   */
  noResultsHeader: PropTypes.objectOf(PropTypes.any),
  /**
   * Settings for noResultsButton section
   */
  noResultsButton: PropTypes.objectOf(PropTypes.any),
  /**
   * Settings for noResult icon
   */
  iconProps: PropTypes.objectOf(PropTypes.any),
};

NoResults.defaultProps = {
  labelKey: 'cmp-no-results-text',
  buttonLabelKey: 'cmp-no-results-button',
  buttonRefreshingLabelKey: 'cmp-no-results-button-refreshing',
  flavor: 'desktop',
  icon: 'broken-heart',
  showButton: true,
  showIcon: true,
  isRefreshing: false,
  onClick: () => {},
  noResultsHeader: {},
  noResultsButton: {},
  iconProps: {
    size: 40,
    iconColor: 'black',
  },
};

NoResults.componentName = 'NoResults';

NoResults.flavors = flavors;

export default withFlavors(NoResults);
